import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { formatShortDateFromNow } from '../../../../../utils/date-utils/dateUtils';
import { Hyperlink } from '../../../../../components/Hyperlink';
import { buildUrlWithParameters } from '../../../../../utils/url-utils/urlUtils';
import { NotificationReadStatus } from '../status/NotificationReadStatus';
import { NotificationWatcherType } from '../../../notification.types';
import { sendNotificationClickedEvent } from '../../../notificationUtils';
import { Connect } from './NotificationWatcherContainer';

type Props = {
  notification: NotificationWatcherType;
  notificationClicked: Function;
  isAlreadyRead: boolean;
};

export class RawNotificationWatcher extends React.Component<Props> {
  onNotificationClicked = (event: React.MouseEvent<HTMLAnchorElement>) => {
    const { notification, notificationClicked } = this.props;
    sendNotificationClickedEvent();
    notificationClicked(notification)(event);
  };

  render() {
    const { notification, isAlreadyRead } = this.props;
    const { watcher } = this.props.notification.data;
    return (
      <Hyperlink
        className="notification-list__link"
        href={buildUrlWithParameters(notification.link, {
          source_notification_id: notification.id,
        })}
        onClick={this.onNotificationClicked}
        data-test-id="notification-watcher"
      >
        <NotificationReadStatus notificationId={notification.id} />
        <span className="notification-list__link__content">
          <span
            className={classNames('notification-watcher__title', {
              'notification-watcher__title--new': !isAlreadyRead,
            })}
          >
            {watcher.query}
          </span>
          <span className="notification-watcher__count">
            {watcher.numberOfNewDecisions}{' '}
            <FormattedMessage id="navigation/notification/components/list/watcher/NotificationWatcher.tsx/1" />
          </span>
          <span className="notification-list__link__date">
            {formatShortDateFromNow(notification.date)}
          </span>
        </span>
      </Hyperlink>
    );
  }
}

export const NotificationWatcher = Connect(RawNotificationWatcher);
